<form fxFlex="grow">
    <div class="dialog">
        <div class="dialog__body">
            <div class="dialog__message" [innerHTML]="this.data">
            </div>
        </div>
        <div class="modal-footer dialog__modal-footer">
            <button type="button" class="btn btn-default reject-button" (click)="onClose()">Close</button>
        </div>
    </div>
</form>